// extracted by mini-css-extract-plugin
export default {"container":"insurance-info_container__SxpmF","icon":"insurance-info_icon__FjHU9","description":"insurance-info_description__rISrz"};